/**
 * 供应商详情 - 基本信息标签页
 */
import React from 'react';
import { Card, Descriptions, Tag } from 'antd';

interface Supplier {
    name?: string;
    code?: string;
    contact_name?: string;
    phone?: string;
    email?: string;
    address?: string;
    payment_terms?: string;
    lead_time_days?: number;
    status?: string;
    link?: string;
    is_factory_audited?: boolean;
    factory_audit_date?: string;
    factory_audit_score?: number;
    audit_grade?: string;
    business_license?: string;
    registered_capital?: number;
    established_year?: number;
}

interface Props {
    supplier: Supplier;
}

const BasicInfoTab: React.FC<Props> = ({ supplier }) => {
    return (
        <Card>
            <Descriptions column={2} bordered>
                <Descriptions.Item label="供应商名称">{supplier.name}</Descriptions.Item>
                <Descriptions.Item label="供应商代码">{supplier.code || '-'}</Descriptions.Item>
                <Descriptions.Item label="联系人">{supplier.contact_name || '-'}</Descriptions.Item>
                <Descriptions.Item label="电话">{supplier.phone || '-'}</Descriptions.Item>
                <Descriptions.Item label="邮箱">{supplier.email || '-'}</Descriptions.Item>
                <Descriptions.Item label="地址" span={2}>{supplier.address || '-'}</Descriptions.Item>
                <Descriptions.Item label="结算方式">{supplier.payment_terms || '-'}</Descriptions.Item>
                <Descriptions.Item label="提前期">{supplier.lead_time_days}天</Descriptions.Item>
                <Descriptions.Item label="状态">
                    <Tag color={supplier.status === 'active' ? 'green' : 'red'}>
                        {supplier.status === 'active' ? '启用' : '停用'}
                    </Tag>
                </Descriptions.Item>
                <Descriptions.Item label="主页链接">
                    {supplier.link ? <a href={supplier.link} target="_blank" rel="noreferrer">{supplier.link}</a> : '-'}
                </Descriptions.Item>
            </Descriptions>

            <h3 style={{ marginTop: 24, marginBottom: 16 }}>工厂资质</h3>
            <Descriptions column={2} bordered>
                <Descriptions.Item label="是否验厂">
                    {supplier.is_factory_audited ? '是' : '否'}
                </Descriptions.Item>
                <Descriptions.Item label="验厂日期">{supplier.factory_audit_date || '-'}</Descriptions.Item>
                <Descriptions.Item label="验厂评分">{supplier.factory_audit_score || '-'}</Descriptions.Item>
                <Descriptions.Item label="验厂等级">{supplier.audit_grade || '-'}</Descriptions.Item>
            </Descriptions>

            <h3 style={{ marginTop: 24, marginBottom: 16 }}>公司信息</h3>
            <Descriptions column={2} bordered>
                <Descriptions.Item label="营业执照号">{supplier.business_license || '-'}</Descriptions.Item>
                <Descriptions.Item label="注册资本">
                    {supplier.registered_capital ? `¥${supplier.registered_capital.toLocaleString()}` : '-'}
                </Descriptions.Item>
                <Descriptions.Item label="成立年份">{supplier.established_year || '-'}</Descriptions.Item>
            </Descriptions>
        </Card>
    );
};

export default BasicInfoTab;
